<template>
  <div class="signup-risk">
    <div class="risknotice">
      <div class="notice-content" @click="notClose">
<!--        <div class="closebutton" @click="closerisknotice">关闭</div>-->
        <div class="whitediv"></div>
        <div class="noticetext">
          <div class="notice-title">风险提示</div>
          <p>1、本次比赛参赛机构自行交易，所有交易须遵守相关法律法规。参赛机构确如有舞弊行为或操纵市场等行为，立即取消参赛机构的参赛资格；由此产生的一切后果由参赛机构承担。</p>
          <p>
            2、本次大赛组委会将本着勤勉尽职的态度竭力保证大赛的顺利进行，但不对参赛产品的任何投资风险、投资损失承担任何责任，也不对因不可抗力的因素或非主办机构所能控制的情况所导致的任何风险、系统故障或由于网络问题导致的系统故障等原因对参赛选手收益率及排名产生的影响等承担任何责任。</p>
          <p>3、参赛产品管理人应就产品参赛事宜向产品持有人进行披露并获得同意，管理人因产品参赛事宜与产品持有人发生纠纷的与大赛主办方无关，所有纠纷及其产生的一切法律和经济责任均由产品管理人自行承担。</p>
          <p>4、本次比赛的最终解释权归大赛主办方所有，主办方有权根据实际情况对大赛规则进行修改或调整，并通过相关途径进行公告。</p>

          <div class="notice-title">大赛规则</div>
          <p>1、参赛条件</p>
          <p>大赛面向全市场私募基金机构管理的私募产品，不指定托管人或经纪商，参赛产品需符合以下条件：</p>
          <p>（1）参赛机构需为中国证券投资基金业协会登记备案的私募基金管理人；参赛产品在参赛前已完成在中国证券投资基金业协会的备案。</p>
          <p>（2）同一参赛机构最多可以报名8个产品进行比赛，同一策略下同一机构最多可以报名3个产品进行比赛。</p>
          <p>（3）产品规模需在1000万元以上。</p>

          <p>2、参赛须知</p>
          <p>（1）比赛期间，主办方提供专属个人中心填报页面，各参赛机构应于每周二17：00前通过页面报送参赛产品上周五的净值和当赛季累计收益。</p>
          <p>（2）参赛期内，各参赛机构应在每季度首月的10个工作日内，委托各自托管人通过托管专用邮箱向指定邮箱（lhmj@kiiik.com）发送当季的净值及当年累计收益列表以便大赛组委进行核对。</p>
          <p>（3）参赛产品要求真实有效，且持续净值更新。若经大赛组委核实净值有误，或净值一个月以上未更新，主办方有权取消参赛资格。</p>

          <p>二、比赛分组</p>
          <p>1、比赛分组：</p>
          <p>权益类、商品及金融衍生品类、固收类、混合类。对使用程序化交易的产品特设程序化特别奖项。</p>

          <p>三、评分方法</p>
          <p>1、评分方法</p>
          <p>主办方根据参赛产品的收益率、累计收益额，以及选取夏普、最大回撤等风险调整指标综合评价产品的表现，同时主办方会根据基金管理人在参赛期间的整体表现情况进行综合打分。</p>
          <table class="table" cellspacing="0">
            <tr style="height: 40px;">
              <th rowspan="6" style="width: 140px;">综合评分</th>
              <th style="width: 180px">维度</th>
              <th style="width: 180px;">权重</th>
            </tr>
            <tr style="height: 40px;">
              <td>净收益率</td>
              <td>40%</td>
            </tr>
            <tr style="height: 40px;">
              <td>累计收益额</td>
              <td>10%</td>
            </tr>
            <tr style="height: 40px;">
              <td>夏普比率</td>
              <td>20%</td>
            </tr>
            <tr style="height: 40px;">
              <td>最大回撤</td>
              <td>20%</td>
            </tr>
            <tr style="height: 40px;">
              <td>专家评审</td>
              <td>10%</td>
            </tr>
          </table>
          <p>四、奖项设置及比赛奖励</p>
          <p>1、奖项设置</p>
          <p>
            大赛根据产品备案信息和合同文本为依据，针对投向类型分设奖项（最佳权益类前三名、最佳商品类前三名、最佳固收类前三名、最佳混合类前三名），报名后当赛季内不得更改。比赛以自然年度为展示周期，2019年9-12月为报名时间，2020年1月1日开始正式计算成绩并展示。程序化参赛产品设立程序化特别奖。所有获奖产品必须是盈利的。</p>
          <p>2、比赛奖励</p>
          <p>获奖机构和产品有机会获得如下奖励：</p>
          <p>1、入选东航金融FOF基金白名单；</p>
          <p>2、入选东航金融推广渠道精选产品名单；</p>
          <p>3、程序化产品有机会享用交易所高速托管机柜。</p>
        </div>
        <div class="agree" @click="closerisknotice">已阅读，并同意</div>
      </div>
    </div>

  </div>
</template>
<script>
  import {http} from '../fetch/api'

  export default {
    data() {
      return {
        closenotice: true,
        nextstep: false,
        firststep: true,
        institutName: "",
        institutRecordNum: "",
        institutRecordAttach: "",
        assetSize: "",
        institutLicenseAttach: "",
        linkman: "",
        linkmanMobile: "",
        linkmanPhone: "",
        linkmanEmail: "",
        linkmanQQ: "",
        hasread: "",
        goodscount: [{}]
      }
    },
    methods: {
      closerisknotice() {
        this.$emit("closerisknotice")
      },
      notClose(event) {
        event.stopPropagation()
      }
    }
  }
</script>
<style scoped>
  .smglrxx, .cscpxx {
    height: 60px;
    line-height: 60px;
    background: #f4f7f9;
  }

  .smglrxx div, .cscpxx div {
    width: 1200px;
    margin: 0 auto;
    font-size: 16px;
  }

  .title {
    height: 67px;
    line-height: 67px;
    text-align: center;
    font-size: 30px;
    letter-spacing: 5px;
    margin: 0 auto 35px auto;
    background-repeat: no-repeat;
    background-size: 750px;
    background-position: center;
  }

  .title span {
    padding-left: 50px;
    display: inline-block;
    background-image: -webkit-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -o-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: -moz-linear-gradient(73deg, #0c3b95, #cf5860);
    background-image: linear-gradient(73deg, #0c3b95, #cf5860);
    -webkit-background-clip: text;
    -ms-background-clip: text;
    -o-background-clip: text;
    -moz-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    -o-text-fill-color: transparent;
    -moz-text-fill-color: transparent;
    text-fill-color: transparent;
    font-weight: bold;

  }

  .bmcs-con > div {
    padding: 50px 0;
    width: 1200px;
    margin: 0 auto;
  }

  .bmcs {
    background-image: url("../assets/bmcs.png");
  }

  .goods-name {
    text-align: center;
    font-family: MicrosoftYaHei-Bold;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    line-height: 32px;
    letter-spacing: 1px;
    color: #007fcf;
    margin-top: 50px;
  }

  .tables {
    margin: 20px auto 0 auto;
    padding: 6px;
    box-sizing: border-box;
    background-repeat: no-repeat;
    background-size: contain;
    position: relative;
  }

  .close {
    position: absolute;
    right: 10px;
    top: -25px;
  }

  .manager-tables {
    width: 880px;
    height: 530px;
    background-image: url("../assets/smglr.png");
  }

  .manager-tables td input {
    width: 580px;
    padding: 0 10px;
    box-sizing: border-box;
    margin: 0;
    border: none;
    height: 52px;
    background: none;
    outline: none;

  }

  .goods-tables {
    width: 977px;
    height: 587px;
    background-image: url("../assets/cscpxx.png");
  }

  table input {
    margin: 0 5px 0 10px;
  }

  table th {
    padding: 0 20px;
    box-sizing: border-box;
  }

  .m-center {
    margin: 30px auto;
    text-align: center;
  }

  .add-goods {
    color: #27a7ea;
    text-decoration: underline;
    cursor: pointer;
    height: 30px;
    line-height: 30px;
  }

  .max-e {
    color: #b5b5b5;
    text-decoration: underline;
    height: 30px;
    line-height: 30px;
  }

  .suresignup {
    width: 400px;
    border-radius: 6px;
    height: 50px;
    line-height: 50px;
    background: #b5b5b5;
    color: #fff;
    margin: 20px auto;
  }

  .risknotice {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba(0, 0, 0, .5);
    z-index: 99;
  }

  .notice-content {
    background-repeat: no-repeat;
    background-size: contain;
    margin: 0 auto;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    background-image: url("../assets/fxgz.png");
    width: 1020px;
    height: 735px;
  }

  .notice-title {
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 22px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 28px;
    height: 28px;
    letter-spacing: 1px;
    margin: 10px 0;
    color: #27a7ea;
  }

  .whitediv {
    height: 60px;
  }

  .noticetext {

    font-size: 16px;
    margin: 0px 65px 30px 65px;
    text-align: left;
    height: 550px;
    overflow: scroll;
  }

  .noticetext p {
    line-height: 28px;
    letter-spacing: 1px;
  }

  /*滚动条整体样式*/
  .noticetext::-webkit-scrollbar {
    width: 8px;
    height: 1px;
  }

  /*滚动条滑块*/
  .noticetext::-webkit-scrollbar-thumb {
    border-radius: 0px;
    -webkit-box-shadow: inset 0 0 2px rgba(0, 0, 0, 0.1);
    background: #a4f1fc;
  }

  /*滚动条轨道*/
  .noticetext::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 1px rgba(0, 0, 0, 0);
    border-radius: 10px;
    background: none;
  }

  .agree {
    text-align: center;
    width: 240px;
    background: #00bcbc;
    margin: 0 auto;
    color: #fff;
    height: 50px;
    line-height: 50px;
    border-radius: 6px;
  }

  .table {
    width: 500px;
    margin: 20px auto;
    text-align: center;
    border-left: solid 1px #232323;
    border-top: solid 1px #232323;
  }

  .table th, .table td {
    border-right: solid 1px #232323;
    border-bottom: solid 1px #232323;
  }

  .closebutton {
    position: absolute;
    color: #fff;
    right: 20px;
    top: -25px;
  }

  .nextstep-con {
    text-align: center;
    margin-top: 30px;
  }

  .agreerisk {
    color: #27a7ea;
  }

  .agreerisk a {
    text-decoration: underline;
  }

  .stepbutton {
    width: 400px;
    height: 50px;
    line-height: 50px;
    margin: 0 auto;
    background: #b5b5b5;
    border-radius: 6px;
    margin-top: 30px;
    color: #fff;
  }

  .goods-tables .fullinput {
    width: 565px;
    height: 52px;
    outline: none;
    background: none;
    border: none;
    padding: 0 10px;
    margin: 0;
    box-sizing: border-box;
  }

  .goods-tables .moreinput, .goods-tables .lessinput {
    height: 48px;
    outline: none;
    background: none;
    border: none;
    padding: 0 10px;
    margin: 0;
    box-sizing: border-box;
  }

  .goods-tables .moreinput {
    width: 60px;
  }

  .goods-tables .lessinput {
    width: 45px;
  }

  .emailinput {
    width: 290px;
    height: 50px;
    margin: 0;
    padding: 0 10px;
    border: none;
    box-sizing: border-box;
    outline: none;

  }
</style>



// WEBPACK FOOTER //
// src/components/risknotice.vue